// 9fbef606107a605d69c0edbcd8029e5d 
export const GLOBAL_ERROR = '_error';
export const DEFAULT = 'DEFAULT';
export const API_ERROR_MESSAGE = 'API service call failed';
export const TCP_APP = 'tcpapp'; // Custom user agent for app
